import React from "react";
import { useStatePtr,useData } from "@pure-ptr/react";

import {
    Box,
    IconButton,
    Tooltip,
    Typography} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { CustomLabel, Loadable, PopoverLink } from "../../../../common";
import ClaimAssignmentDialog from "../../ClaimAssignmentDialog/ClaimAssignmentDialog";
import { Edit as EditIcon } from "@mui/icons-material";
import { AssignedClaimsHistory } from "./AssignedClaimsHistory";
import { getClaimHistory } from "../../../../store/api/claimAssignment";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
    autoComplete: {
        width: "100%",
        "& .MuiFormControl-marginNormal": {
            marginTop: 0,
        },
    },
    box: {
        display: "inline-block",
    },
    underline: {
        textDecoration: "underline",
        color: "#2739c1",
        cursor: "pointer",
    },
    rightBox: {
        display: "inline-block",
        float: "right",
    },
}));

const AssignClaimSection = ({claimAllDetails,assignClaimsCallback}) => {
    const classes = useStyles();
    const dialogOpenPtr = useStatePtr(false);
    const dialogAssignedClaims = useStatePtr(false);
    // To avoid auto history api call create state pointer
    const [assignedClaimsHistory, setAssignedClaimsHistory] = React.useState(0);
    let users: any = useSelector((state: any) => state?.users?.data);
    let currentAssignedUserGoodName=users?.find((item)=>item?.username==claimAllDetails?.assignedTo)?.username || ""
    

    const {
            data: assignedClaimData,
            isPending,
            error,
            reload,
        } = useData(async () => {
            if (!claimAllDetails?.id ) return;
            if (!Boolean(assignedClaimsHistory)) return;
            if (!dialogAssignedClaims.value) return;
            // return;
            const assignedClaimData = await getClaimHistory(claimAllDetails?.id);
            return assignedClaimData;
        }, [claimAllDetails?.id, assignedClaimsHistory]);
        
    return (
        <>
            <CustomLabel
                label="Assigned To"
                data={
                    <PopoverLink
                        columnData={currentAssignedUserGoodName || "Unassigned"}
                        title={"Unassigned"}
                        customClasses="aligned-content"
                    />
                }
                type="claim-contract"
            />

            <Box className={classes.box}>
                <Tooltip title="Assign Claim">
                    <IconButton
                        className="ml-2 p-1"
                        aria-label="Edit"
                        onClick={() => dialogOpenPtr.set(true)}
                        size="large"
                    >
                        <EditIcon style={{ fontSize: "22px" }} />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box className={classes.rightBox}>
                <Typography
                    onClick={() => {
                        setAssignedClaimsHistory(assignedClaimsHistory + 1);
                        dialogAssignedClaims.set(true)
                    }}
                    color="primary"
                    className={`${classes.underline}`}
                >
                    History
                </Typography>
            </Box>

            <ClaimAssignmentDialog
                openPtr={dialogOpenPtr}
                handleClose={() => dialogOpenPtr.set(false)}
                selectedClaimsIds={[claimAllDetails?.id]}
                callBack={() => {
                    assignClaimsCallback();
                    reload();
                }}
                defaultAssigned={currentAssignedUserGoodName}
            />
            <AssignedClaimsHistory
                openPtr={dialogAssignedClaims}
                handleClose={() => dialogAssignedClaims.set(false)}
                isPending={isPending}
                assignedClaimData={assignedClaimData}
                reload={reload}
            />
        </>
    );
};

export default AssignClaimSection;
